<template>
  <v-card>
    <Cabecera 
      v-if="!incrustado" 
      tipoModuloActual="pbc"
      :incrustado="incrustado"/>
    <StepperPortal v-if="!incrustado" tipoModuloActual="pbc" />
    <v-container fluid>
      <o-big-title v-if="incrustado">{{titulo}}</o-big-title>
      <DocumentacionTerminado 
        v-if="incrustado"
        :cargandoExterior="cargandoExterior"
        :incrustado="incrustado"
        :tipo="'pbc'"
        @continuar="terminar"
      />
      <div v-else>
        <v-form ref="form" v-model="valid">
          <BaseKyc
            class="mb-3"
            :compradores.sync="compradores"
            :expansion.sync="expansion"
            :incrustado="incrustado"
            :cargandoExterior="cargandoExterior"
            :waitingForLoad="waitingForLoad"
            :mostrarDescripcion="true"
            :tipo="'pbc'"
          />
          <BaseDocumentacion
            :compradores.sync="compradoresDocumentacion"
          />
        </v-form>
        <!-- Validador -->
        <v-layout v-if="pbcRevisando" column my-4>
          <o-medium-title> {{$t('reservas.pbc.validacion')}}</o-medium-title>
          <o-base-text :marginBottom="false" class="mb-1">
            {{$t('reservas.pbc.validaDatos')}}
          </o-base-text>
          <o-base-text :marginBottom="false" class="mb-2">
            {{$t('reservas.pbc.noValidar')}}
          </o-base-text>          
          <v-radio-group
            v-model="validarTodo"
            hide-details
            class="pl-2 mb-4"
          >
            <v-layout>
              <v-radio
                color="primary"
                :label="$t('reservas.pbc.si')"
                :value="true"
                class="mb-0"
              />
              <v-radio
                selected
                color="primary"
                :label="$t('reservas.pbc.no')"
                :value="false"
                class="mb-0"
              />
            </v-layout>
          </v-radio-group>
          <v-slide-y-transition>
            <v-layout v-if="validarTodo === false" column mb-2>
              <o-base-text :marginBottom="false">
                {{$t('reservas.pbc.addComentarios')}}
              </o-base-text>
              <v-textarea
                v-model="textoValidacion"
                auto-grow
              />
            </v-layout>
          </v-slide-y-transition>
        </v-layout>
        <!-- Botonera -->
        <v-layout justify-space-between align-center>
          <v-flex xs2>
            <v-btn
              flat
              class="titleColor--text ml-0 pl-0"
              :disabled="waitingForLoad  || cargandoExterior"
              @click="$router.push({
                name: 'reservas.id',
                params: {id: reserva.id}
              })"
              v-if="!incrustado"
              :icon="$vuetify.breakpoint.xsOnly"
            >
              <!-- eslint-disable-next-line -->
              <v-icon class="mr-1">{{$vuetify.breakpoint.xsOnly ? 'arrow_back':'chevron_left'}}</v-icon>
              <span class="hidden-xs-only">{{$t('general.misc.volver')}}</span>
            </v-btn>
          </v-flex>
          <v-layout 
            :column="$vuetify.breakpoint.smAndDown" 
            :shrink="$vuetify.breakpoint.smAndDown" 
            justify-space-around
          >
            <v-btn 
              v-if="pbcRevisando"
              large
              color="primary"
              :disabled="waitingForLoad || cargandoExterior"
              :loading="waitingForLoad || cargandoExterior"
              @click="validar()"
            >
              {{$t('general.misc.continuar')}}
            </v-btn>
          </v-layout>
          <v-flex xs2/>
        </v-layout>
      </div>
    </v-container>
  </v-card>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'
import BaseKyc from '@/components/reservas/comprador/BaseKyc'
import BaseDocumentacion from '@/components/reservas/documentacion/BaseDocumentacion'
import MixinComprador from '@/mixins/comprador'
import MixinEstadoPbc from '@/mixins/estadosReserva/estadoPbc'
import MixinDocumentacion from '@/mixins/documentacion'
import DocumentacionTerminado from '@/components/reservas/documentacion/DocumentacionTerminado'
import Cabecera from '@/components/Cabecera'
import StepperPortal from '@/components/StepperPortal'

export default {
  mixins: [rules, MixinComprador, MixinEstadoPbc, MixinDocumentacion],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    actual: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      compradores: [],
      compradoresDocumentacion: [],
      expansion: [],
      valid: false,
      validarTodo: null,
      textoValidacion: ''
    }
  },
  created () {
    this.inicializarCompradores()
    // modificar esto para utilizar sólo un array de compradores
    this.compradoresDocumentacion = this.getCompradores.map(x => {
      let retorno = {...x}
      retorno.documentacion = []
      // Insertar documentos que faltan con null
      this.carpetas.forEach(carpeta => {
        let documentos = x.documentacion.filter(d => d.carpetaId === carpeta.id)
        retorno.documentacion.push({
          carpetaId: carpeta.id,
          tipoObjetoId: carpeta.tipoObjetoId,
          objetoId: retorno.id,
          carpeta: carpeta,
          documento: documentos.map(doc => {
            return {
              extension: doc.documento.extension,
              id: doc.documento.id,
              mime: doc.documento.mime,
              nombre: doc.documento.nombre,
              descripcionDocumento: doc.descripcionDocumento ? doc.descripcionDocumento : '',
              validado: doc.validado
            }
          }),
          validado: null
        })
      })
      retorno.documentacion = this.documentacionFiltrada(retorno)
      return retorno
    })
  },
  components: {
    BaseKyc,
    DocumentacionTerminado,
    BaseDocumentacion,
    Cabecera,
    StepperPortal
  },
  computed: {
    ...mapGetters({
      getCompradores: 'compradores/getAll',
      usuario: 'login/usuario',
      inmuebles: 'promociones/inmuebles/getAll',
      modulos: 'modulosOrdenes/modulos/getAll',
      tarifa: 'promociones/inmuebles/tarifas/getActual',
      promociones: 'promociones/getAll',
      reservaActual: 'reservas/_id/getActual',
      carpetas: 'carpetas/getAll'
    }),
    reserva () {
      return this.reservaActual
    },
    inmueble () {
      return this.inmuebles[0]
    },
    titulo () {
      return this.getTexto('modulos.pbc')
    },
    promocion () {
      return this.promociones[0]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      validarPbc: 'pbc/validarPbc'
    }),
    terminar (terminar = true) {
      this.$emit('cambiado', false)
      this.$emit('terminado', terminar)
    },
    async validar () {
      if (this.validarTodo === null) {
        this.addAlert({texto: this.$t('reservas.pbc.validoSiNo'), color: 'error'})
        return
      } else if (!this.validarTodo) {
        if (this.textoValidacion === '') {
          this.addAlert({texto: this.$t('reservas.pbc.rechazarAddComentario'), color: 'error'})
          return
        }
      }
      try {
        this.waitingForLoad = true
        await this.validarPbc({
          id: this.reserva.id,
          validacion: {
            validado: this.validarTodo,
            textoValidacion: this.textoValidacion
          }
        })
        this.$emit('terminado', this.validarTodo)
        this.addAlert({texto: this.validarTodo ? this.$t('reservas.pbc.pbcValidado') : this.$t('reservas.pbc.pbcEliminado'), color: 'success'})
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/pbc/Pbc.vue